<template>
  <div>
    <shop-banner-mobile />
    <div class="container bg-white">
      <div class="row no-gutters justify-content-md-center">
        <div class="col-xs-12 col-md-6">
          <GiftCard
            :storeid="storeid"
            :subtitle="giftCardSubHeaderText"
            :title="giftCardHeaderText"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GiftCard from "./GiftCard.vue";
import ShopBannerMobile from "../../../components/shop/partials/shopBannerMobile.vue";
import { mapGetters } from "vuex";

export default {
  components: { ShopBannerMobile, GiftCard },
  props: {
    storeid: {
      type: String,
      default: "",
    },
    productId: {
      type: Number,
    },
    menuLoaded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["currentStoreDoc"]),
    cardSelected: {
      get() {
        return this.$store.getters["newGiftShoppingCart/cardSelected"];
      },
    },
    giftCardHeaderText() {
      if (!this.currentStoreDoc)
        return "The Perfect Foodie Gift for Every Occasion!";
      return (
        this.currentStoreDoc.HeaderTextGiftcard ||
        "The Perfect Foodie Gift for Every Occasion!"
      );
    },
    giftCardSubHeaderText() {
      if (!this.currentStoreDoc)
        return "Get the gift of food delivery for yourself or a friend!";
      return (
        this.currentStoreDoc.SubheaderTextGiftcard ||
        "Get the gift of food delivery for yourself or a friend!"
      );
    },
  },
  data() {
    return {
      imageUrlList: ["card1.png", "card2.png", "card3.png", "card4.png"],
      loadedStoreMenu: null,
    };
  },

  methods: {
    setFavicon(faviconUrl) {
      const uniqueUrl = `${faviconUrl}?v=${new Date().getTime()}`;

      // Remove any existing favicon
      let link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.remove();
      }

      // Add the new favicon
      link = document.createElement("link");
      link.rel = "icon";
      link.href = uniqueUrl;
      document.head.appendChild(link);

      // Safari workaround: Temporarily change rel attribute
      setTimeout(() => {
        link.rel = "shortcut icon";
        link.rel = "icon";
      }, 100);
    },

    updateFavicon() {
      if (this.currentStoreDoc && this.currentStoreDoc.Logo) {
        this.setFavicon(this.currentStoreDoc.Logo);
      }
    },

  },


  watch: {
    currentStoreDoc: {
      handler(newVal) {
        if (newVal && newVal.Logo) {
          this.setFavicon(newVal.Logo);
        }
      },
      immediate: true, // Trigger immediately
    },
  },
  mounted() {
    // Update favicon
    this.updateFavicon();
  },
};
</script>

<style scoped>
.gift-card-button {
  background-color: #ffffff;
  font-family: Open Sans;
  margin-top: 1%;
  color: black;
  position: absolute;
  right: 13.8%;
  padding: 5px;
  border-radius: 5px;
}
.giftcard-wrapper {
  height: 92%;
  /* width: 100%; */
  width: 580px;
  padding: 2% 0;
  margin: 0 auto;
  box-sizing: border-box;
}

@media only screen and (max-width: 900px) {
  .logo-icon {
    height: 90px;
    margin-left: -9px;
  }
  .gift-card-button {
    top: 20px;
    right: 0;
  }

  .giftcard-wrapper {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .logo-icon {
    height: 70px;
    margin-left: -9px;
  }
}
</style>
